import { render, staticRenderFns } from "./RelacionarUsuarios.vue?vue&type=template&id=c040c0f8"
import script from "./RelacionarUsuarios.vue?vue&type=script&lang=js"
export * from "./RelacionarUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports